import { Nilable } from "@shared/utils";

export interface IBigmlAppsDTO {
    apps_list: Nilable<IBigmlAppDTO[]>;
}

export class BigmlAppsDTO {
    public appsList: BigmlAppDTO[] = [];

    constructor(json: Nilable<Partial<IBigmlAppsDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlAppsDTO>) {
        if (json.apps_list != null) {
            this.appsList = json.apps_list.map(app => new BigmlAppDTO(app));
        }
    }

    public toJSON(): IBigmlAppsDTO {
        return {
            apps_list: this.appsList.map(app => app.toJSON())
        };
    }
}

export interface IBigmlAppDTO {
    app_name: string;
    average: number;
}

export class BigmlAppDTO {
    public appName = "";
    public average = 0;

    constructor(json: Nilable<Partial<IBigmlAppDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlAppDTO>) {
        if (json.app_name != null) {
            this.appName = json.app_name;
        }
        if (json.average != null) {
            this.average = json.average;
        }
    }

    public toJSON(): IBigmlAppDTO {
        return {
            app_name: this.appName,
            average: this.average
        };
    }
}
